<template>
  <div class="part-class">
    <div id="footer">
      <div class="part-class-btn">合作伙伴</div>
      <div class="part">
        <div v-for="item in partner" :key="item.id" class="part-single">
          <el-link :href="item.redirect" target="_blank" :underline="false">
            <img :src="item.img" alt />
          </el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      partner: []
    };
  },
  created() {
    this.getPartner();
  },
  methods: {
    getPartner() {
      this.httpGet(this.$root.getPartner, {})
        .then(result => {
          this.partner.push(...result.list);
        })
        .catch(err => {
          console.error('getPartner-err', err);
        });
    },
    top() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.part-class {
  background: white;
  // width: 78.458%;
  padding: 50px 0;
}

.part-class-btn {
  margin-bottom: 16px;
  font-size: 20px;
  font-weight bold
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
}

.part {
  width: 100%;
  min-height: 54px;
  height: auto;
  // padding: 12px 20px 0 17px;
  flex-x(flex-start);
  flex-wrap: wrap;
}

.part-single {
  // border: 1px solid red;
  width: 211px;
  height: 54px;
  float: left;
  margin-right: 25px;
  margin-bottom: 16px;
}

img {
  width: 211px;
  height: 54px;
}
</style>
